// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__XALh5YvRvNWWE","text":"text__yV3n45PmE90rx"};